import { Divider, Input, Modal } from "antd";
import React, { useState } from "react";
import {
  TQuestion,
  TQuizAttempt,
} from "../../../../entities/Moodle/model/MoodleTypes";
import Question from "./Question";
import { moodleApi } from "../../../../entities/Moodle";
import { ErrorText } from "../../../../shared/ui";

const QuestionModal = ({
  attempt,
  setQuestions,
  setQuizAttempts,
  questions,
  isOpen,
  setIsOpen,
}: {
  setQuestions: any;
  setQuizAttempts: any;
  attempt: TQuizAttempt | null;
  questions: TQuestion[];
  isOpen: boolean;
  setIsOpen: (state: boolean) => void;
}) => {
  const [error, setError] = useState("");
  const handleOk = () => {
    moodleApi
      .finish_attempt({
        attempt_id: attempt?.id,
        quiz_id: attempt?.quiz,
      })
      .then((response) => {
        console.log("response data", response.data);
        if (response.data?.exception) {
          setError(response.data?.message);
        } else {
          setQuizAttempts(response.data.attempts);
          setIsOpen(false);
        }
      })
      .catch((e) => {
        setError(e);
      });
  };
  return (
    <Modal
      title="Вопросы"
      open={isOpen}
      onOk={handleOk}
      maskClosable={false}
      okText="Завершить"
      cancelText="Закрыть"
      onCancel={() => setIsOpen(false)}
    >
      <div>
        {error.length > 0 && <ErrorText error={error} />}
        <div>Попытка №{attempt?.attempt}</div>
        <div style={{ marginLeft: 20, marginTop: 15 }}>
          {questions.map((question, index) => {
            return (
              <Question
                setQuestions={setQuestions}
                key={index}
                question={question}
                attempt={attempt}
              />
            );
          })}
        </div>
      </div>
    </Modal>
  );
};

export default QuestionModal;
